export const PORTAL_VIEW_CLAIM = 'custom:portal_view';
export const PORTAL_VIEW_OPS = 'ops';
export const PORTAL_VIEW_RETAIL = 'retail';
export const UI_ROLE_RETAIL_ADMIN = 'retailadmin';

export type PortalView = 'ops' | 'retail';

export const RETAIL_ALLOWED_PATH_PREFIXES = [
	'/dashboard',
	'/new-dashboard',
	'/voucher',
	'/banners',
	'/user-settings',
	'/error'
];

export function getPortalViewFromAttributes(userAttr: Record<string, unknown> | null | undefined): PortalView {
	if (!userAttr) {
		return PORTAL_VIEW_OPS;
	}
	const role = String(userAttr['custom:role'] || '');
	const view = String(userAttr[PORTAL_VIEW_CLAIM] || '').trim().toLowerCase();
	if (view === PORTAL_VIEW_RETAIL && role === 'campusadmin') {
		return PORTAL_VIEW_RETAIL;
	}
	return PORTAL_VIEW_OPS;
}

export function isRetailPortal(userAttr: Record<string, unknown> | null | undefined): boolean {
	return getPortalViewFromAttributes(userAttr) === PORTAL_VIEW_RETAIL;
}

export function isRetailPortalPathAllowed(url: string | null | undefined): boolean {
	const path = String(url || '').split('?')[0];
	if (!path) {
		return false;
	}
	return RETAIL_ALLOWED_PATH_PREFIXES.some((prefix) => path === prefix || path.indexOf(prefix + '/') === 0);
}

export function isCampusScopedUiRole(role: string | null | undefined): boolean {
	return role === 'campusadmin' || role === UI_ROLE_RETAIL_ADMIN;
}

export function toUiRole(role: string | null | undefined, portalView?: string | null): string {
	if (role === 'campusadmin' && String(portalView || '').trim().toLowerCase() === PORTAL_VIEW_RETAIL) {
		return UI_ROLE_RETAIL_ADMIN;
	}
	return role || '';
}

export function toPersistedRoleAndPortalView(uiRole: string | null | undefined): { role: string; portal_view: PortalView } {
	if (uiRole === UI_ROLE_RETAIL_ADMIN) {
		return { role: 'campusadmin', portal_view: PORTAL_VIEW_RETAIL };
	}
	return { role: uiRole || '', portal_view: PORTAL_VIEW_OPS };
}

export function formatRoleLabel(role: string | null | undefined, portalView?: string | null): string {
	switch (toUiRole(role, portalView)) {
		case 'sadmin':
			return 'Super Admin';
		case 'distiadmin':
			return 'Partner Admin';
		case 'marketadmin':
			return 'Market Admin';
		case 'clientadmin':
			return 'Client Admin';
		case UI_ROLE_RETAIL_ADMIN:
			return 'Retail Admin';
		case 'campusadmin':
			return 'Campus Admin';
		default:
			return 'NA';
	}
}

export function isRetailAdminUiRole(role: string | null | undefined): boolean {
	return role === UI_ROLE_RETAIL_ADMIN;
}

export function shouldOfferRetailAdminRole(
	vouchersEnabled: boolean,
	currentUiRole?: string | null
): boolean {
	return !!vouchersEnabled || isRetailAdminUiRole(currentUiRole);
}

export function canPersistRetailPortalView(
	vouchersEnabled: boolean,
	existingUiRole?: string | null
): boolean {
	return !!vouchersEnabled || isRetailAdminUiRole(existingUiRole);
}

export function portalViewAllowsMenuItem(item: { page?: string } | null | undefined, portalView: PortalView): boolean {
	if (portalView !== PORTAL_VIEW_RETAIL) {
		return true;
	}
	if (!item || !item.page) {
		return true;
	}
	return isRetailPortalPathAllowed(item.page);
}
